<!--
 * @Author: zhaoyang
 * @Date: 2020-10-19 16:17:28
 * @LastEditors: zheng zheng@sence.sg
 * @LastEditTime: 2022-12-07 19:19:51
 * @Description: 退款詳情狀態與操作
-->
<template>
  <div class="refound-status">
    <div
      v-if="refoundInfo.orderDto && refoundInfo.orderDto.status == 'Invalid'"
    >
      <p class="header-title">
        <fps-icon class="status-icon" color="#3BBC2A" :type="iconName" />
        <span>退款成功</span>
      </p>
      <p v-show="!refoundInfo.canContinueRefund" class="status-desc">
        退款金額已經返回下單用戶帳戶
      </p>
      <p v-show="refoundInfo.canContinueRefund" class="status-desc">
        7天內可繼續退剩餘未完成訂單。
      </p>
    </div>
    <div
      v-else-if="
        refoundInfo.orderDto && refoundInfo.orderDto.status == 'REFUND_SUCCESS'
      "
    >
      <p class="header-title">
        <fps-icon class="status-icon" color="#3BBC2A" :type="iconName" />
        <span>退款成功</span>
      </p>
      <p class="status-desc">退款金額已經返回下單用戶帳戶</p>
    </div>
    <div
      v-else-if="
        refoundInfo.orderDto && refoundInfo.orderDto.status == 'Controversy'
      "
    >
      <p class="header-title">
        <fps-icon class="status-icon" color="#FE7F38" :type="iconName" />
        <span>申請退款中</span>
      </p>
      <h4 class="count-down">剩{{ comCreateTime | tuiFormartDate }}</h4>
    </div>
    <div
      v-else-if="
        refoundInfo.orderDto && refoundInfo.orderDto.status == 'Negotiate'
      "
    >
      <p class="header-title">
        <fps-icon class="status-icon" color="#E63B37" :type="iconName" />
        <span>已拒絕退款請求</span>
      </p>
      <p class="status-desc">
        拒絕後客服可能介入處理，若客服無處理，訂單將在7天後自動完成。
      </p>
      <reject-detail :refoundInfo="refoundInfo"></reject-detail>
    </div>
    <div
      v-if="
        refoundInfo.orderDto && refoundInfo.orderDto.status == 'Controversy'
      "
      class="handles"
    >
      <div class="handle-button" @click="refuseRefound">拒絕退款</div>
      <div class="handle-button special-button" @click="confirmRefound">
        確認退款
      </div>
      <!-- <div class="handle-button special-button" @click="goRefound">
        繼續退款
      </div> -->
    </div>
    <!-- <div v-show="refoundInfo.canContinueRefund" class="handles">
      <div class="handle-button right-button" @click="goRefound">繼續退款</div>
    </div> -->
  </div>
</template>
<script>
import rejectDetail from './refound-reject-detail';
const DayGetTime = 86400000; // 24小時對應豪秒數
export default {
  components: {
    rejectDetail
  },
  props: {
    refoundInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    comCreateTime() {
      const endTime = new Date(this.refoundInfo.createTimeStamp).getTime();
      const startTime = new Date().getTime();
      return startTime - endTime < 0
        ? DayGetTime
        : DayGetTime - (startTime - endTime);
    },
    iconName() {
      return 'passed';
    },
    statusText() {
      let statusText = '';
      if (this.refoundInfo.orderDto && this.refoundInfo.orderDto.status) {
        switch (this.refoundInfo.orderDto.status) {
          case 'Invalid':
            statusText = '退款成功';
            break;
          case 'Controversy':
            statusText = '申請退款已提交，等待陪玩師確認';
            break;
          case 'Negotiate':
            statusText = '陪玩師拒絕退款請求';
            break;

          default:
            break;
        }
      }
      return statusText;
    },
    statusDesc() {
      return '24小時內陪玩師沒回覆，退款將自動生效，金額返回您的帳戶';
    }
  },
  methods: {
    goRefound() {
      this.$emit('gobRefound', 'borderRound');
    },
    refuseRefound() {
      this.$confirm({
        content: '拒絕需提供充分的理由與證據；拒絕後客服將視情況介入處理',
        title: '確認拒絕退款嗎？',
        confirmButtonText: '確認拒絕',
        cancelButtonText: '再想想',
        closeOnClickModal: true,
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$emit('goToRefuseRefound', 'refuseRefound');
      });
    },
    confirmRefound() {
      this.$confirm({
        content: '退款後將無法進行修改，確認退款嗎？',
        title: '確認拒絕退款嗎？',
        confirmButtonText: '確認退款',
        cancelButtonText: '再想想',
        closeOnClickModal: false
      }).then(() => {
        this.$http
          .post('/order/accept/return/master', {
            uuid: this.refoundInfo.orderDto.orderNo
          })
          .then(() => {
            this.$emit('getRefoundDetail', true);
          })
          .catch(() => {});
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.refound-status {
  background: #ffffff;
}
.header-title {
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #222c43;
  display: flex;
  align-items: center;
}
.status-countdown {
  padding: 0 0 20px 26px;
  border-bottom: 1px solid #f1f4f6;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #636d86;
  line-height: 10px;
}
.status-icon {
  margin-right: 6px;
  vertical-align: middle;
}
.status-desc {
  font-size: 12px;
  line-height: 17px;
  color: #636d86;
  margin-top: 3px;
}
.border-desc {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f1f4f6;
}
.count-down {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #636d86;
  margin-left: 24px;
}
.handles {
  padding: 20px 0;
  text-align: right;
}
.handle-button {
  cursor: pointer;
  display: inline-block;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #e8eaee;
  margin-right: 10px;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
  border-radius: 25px;
  color: #636d86;
}
.special-button {
  @include button-yellow;
  margin-right: 0;
}
.right-button {
  margin-right: 0;
}
</style>
